import {
  CheckCircleFilled,
  CheckCircleOutlined,
  LoadingOutlined,
  StarFilled,
  StarOutlined,
  SlidersOutlined,
  PlusCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons'
import {
  Checkbox,
  Col,
  Collapse,
  Pagination,
  Popconfirm,
  Row,
  Tooltip,
  message,
  Button,
  Input,
  Popover,
  Space,
  Select,
  InputNumber,
  Badge
} from 'antd'
import axios from 'axios'
import { runInAction, toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, {
  useCallback,
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
} from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { grayPrimary, greenPrimary } from '../../../color'
import { AvatarHasName } from '../../../components/Common/Avatar'
import { EmptyText } from '../../../components/Common/CellText'
import { StatusTag } from '../../../components/Common/StatusTag'
import TableComponent from '../../../components/Common/TableComponent'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PopoverWatchTime from '../../../components/PopoverWatchTime'
import UnreadTextWork from '../../../components/UnreadText/UnreadTextWork'
import AppPageHeader from '../../../components/AppPageHeader'
import AdvanceFilterBlock from './AdvanceFilterBlock'
import useImsatSync from '../../../hooks/useImsatSync'
import SyncImsatCredentialsModal from '../../../components/Shared/SyncImsatCredentialsModal'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_SLASH,
  STATUS_DEFAULT,
  TYPE_STATUS,
  VIEWLOG_DATE,
  WORK_STATUS,
} from '../../../constants'
import date_format from '../../../date_format'
import { WorkRequest } from '../../../requests/WorkRequest'
import commandStore from '../../../stores/commandStore'
import utils from '../../../utils'
import { CheckIcon, ContentBlock, StarIcon } from '../WorkStyledPage'

const { Panel } = Collapse

const ListWork = props => {
  const {
    workStore,
    selectUserStore,
    selectPeopleStore,
    authenticationStore,
    aclStore,
    loadingAnimationStore,
    handleOpenDrawerWork,
    listHandler,
    isUnread,
    documentAccessibilityStore,
  } = props
  const { currentUser } = authenticationStore
  const {
    workList,
    workDetail,
    queryParams,
    totalWork,
    workListV2,
    totalWorkV2,
  } = workStore
  const history = useHistory()
  const location = useLocation()
  const queryStringParsed = queryString.parse(location.search, {
    arrayFormat: 'index',
  })
    const [showAdvanceFilter, setShowAdvanceFilter] = useState(false)
    const [searchValue, setSearchValue] = useState(queryStringParsed.title || '')
    const filterBtnRef = useRef(null)

    const handleQuickSearch = value => {
      let newQueryString = {
        ...queryParams,
        title: value,
        page: 0,
      }
      workStore.setQueryParams(newQueryString)
      const queryStringStringify = queryString.stringify(newQueryString, {
        skipNull: true,
      })
      history.replace({
        pathname: '/works',
        search: queryStringStringify,
      })
    }

  const {
    isSyncing,
    syncModalVisible,
    syncUsername,
    setSyncUsername,
    syncPassword,
    setSyncPassword,
    rememberPassword,
    setRememberPassword,
    hasSavedPassword,
    syncError,
    openSyncModal,
    closeSyncModal,
    handleSync,
  } = useImsatSync({
    defaultUsername: currentUser?.username,
    onSyncComplete: async () => {
      if (isCurrentUserIncluded === true) {
        await workStore.getWorkListV2()
      } else {
        await workStore.getWorkList()
      }
    },
  })

  const params = useParams()
  const [allWorks, setAllWorks] = useState([])
  const [viewAllWorks, setViewAllWorks] = useState([])
  const [totalWorksCount, setTotalWorksCount] = useState()
  const userNames = viewAllWorks?.map(item => item.assignee.user_name)
  const isCurrentUserIncluded = userNames?.includes(currentUser?.username)

  useEffect(() => {
    const fetchWorkList = async () => {
      try {
        const fetchWorks = isUnread
          ? workStore.getWorkListV3({
              ...queryParams,
              is_unread: isUnread,
            })
          : workStore.getWorkListV2()
        const [workRes, accessRes] = await Promise.all([
          fetchWorks,
          documentAccessibilityStore.getDocumentAccessibilities(
            'WORKS',
            'VIEW_ALL'
          ),
        ])
        setTotalWorksCount(workRes.total_count)
        setAllWorks(workRes.data)
        setViewAllWorks(accessRes.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchWorkList()
  }, [listHandler])

  useEffect(() => {
    if (!authenticationStore.currentUser) return
    if (
      queryStringParsed.assignee &&
      Array.isArray(queryStringParsed.assignee)
    ) {
      queryStringParsed.assignee.forEach(item => {
        const itemInfo = item.split(',')
        const username = itemInfo[0].split('=')[1]
        if (itemInfo.includes(ASSIGNEE_TYPE.USER)) {
          selectPeopleStore.setSelectUserData({
            ...selectPeopleStore.selectUserData,
            [itemInfo[2]]: [
              {
                assignee_type: ASSIGNEE_TYPE.USER,
                full_name: itemInfo[3],
                id: username,
                permission: itemInfo[2],
                department_code: null,
                department_name: null,
                image_id: null,
                position_name: null,
              },
            ],
          })
        }
        if (itemInfo.includes(ASSIGNEE_TYPE.DEPARTMENT)) {
          selectPeopleStore.setSelectDepartmentData({
            ...selectPeopleStore.selectDepartmentData,
            [itemInfo[2]]: [
              {
                assignee_type: ASSIGNEE_TYPE.DEPARTMENT,
                full_name: itemInfo[3],
                id: username,
                permission: itemInfo[2],
                department_code: null,
                department_name: null,
                image_id: null,
                position_name: null,
              },
            ],
          })
        }
        if (itemInfo.includes(ASSIGNEE_TYPE.GROUP)) {
          selectPeopleStore.setSelectGroupData({
            ...selectPeopleStore.selectGroupData,
            [itemInfo[2]]: [
              {
                assignee_type: ASSIGNEE_TYPE.GROUP,
                full_name: itemInfo[3],
                id: username,
                permission: itemInfo[2],
                department_code: null,
                department_name: null,
                image_id: null,
                position_name: null,
              },
            ],
          })
        }
      })
    }
  }, [authenticationStore.currentUser])

  const reducer = (state, action) => {
    switch (action.type) {
      case ASSIGNEE_TYPE.CREATE:
        return {
          ...state,
          [ASSIGNEE_TYPE.CREATE]:
            action.value &&
            `assignee=${encodeURIComponent(action.value)},${
              action.assigneeType
            },${ASSIGNEE_TYPE.CREATE},${action.fullName || 'unknown'}`,
        }
      case ASSIGNEE_TYPE.COMBINER:
        return {
          ...state,
          [ASSIGNEE_TYPE.HANDLER]:
            action.value &&
            `assignee=${encodeURIComponent(action.value)},${
              action.assigneeType
            },${ASSIGNEE_TYPE.HANDLER},${action.fullName || 'unknown'}`,
        }
      default:
        return {
          [ASSIGNEE_TYPE.CREATE]: null,
          [ASSIGNEE_TYPE.COMBINER]: null,
        }
    }
  }

  // Initialize the usersFilter and clear assignee on page reload
  const [usersFilter, dispatchUserFilter] = useReducer(reducer, {
    [ASSIGNEE_TYPE.CREATE]: null,
    [ASSIGNEE_TYPE.COMBINER]: null,
  })

  useEffect(() => {
    if (params?.code_work) return

    runInAction(() => {
      workStore.queryParams = {
        page: queryStringParsed.page || 0,
        size: queryStringParsed.size || 10,
        title: queryStringParsed.title,
        from_date: queryStringParsed.from_date,
        to_date: queryStringParsed.to_date,
        status: queryStringParsed.status,
        work_type: queryStringParsed.work_type,
        permission: queryStringParsed.permission,
        parent_id: queryStringParsed.parent_id,
        is_important: queryStringParsed.is_important,
        is_unread: queryStringParsed.is_unread || isUnread,
        assignee: Object.values(usersFilter)
          .filter(item => item)
          .map(item => {
            const assignee = item.split(',')
            if (assignee.length === 3) {
              return assignee.join()
            }
            assignee.pop()
            return assignee.join()
          })
          .join('&'),
      }
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParsed,
        is_unread: queryStringParsed.is_unread || isUnread,
        assignee: Object.values(usersFilter),
        [ASSIGNEE_TYPE.CREATE]:
          typeof usersFilter[ASSIGNEE_TYPE.CREATE] === 'string'
            ? usersFilter[ASSIGNEE_TYPE.CREATE].split(',')[0].substring(9)
            : null,
        [ASSIGNEE_TYPE.COMBINER]:
          typeof usersFilter[ASSIGNEE_TYPE.HANDLER] === 'string'
            ? usersFilter[ASSIGNEE_TYPE.HANDLER].split(',')[0].substring(9)
            : null,
        [ASSIGNEE_TYPE.FOLLOWER]:
          typeof usersFilter[ASSIGNEE_TYPE.FOLLOWER] === 'string'
            ? usersFilter[ASSIGNEE_TYPE.FOLLOWER].split(',')[0].substring(9)
            : null,
      },
      {
        skipNull: true,
        arrayFormat: 'index',
      }
    )
    history.replace(`/works?${queryStringStringify}`)
  }, [usersFilter || listHandler])

  const handleOpenWorkDetail = useCallback(
    async code => {
      loadingAnimationStore.setShowSpinInline(true)
      handleOpenDrawerWork()
      try {
        const response = await workStore.getWorkDetail(code)
        WorkRequest.markAsReadWork(code)
        if (response.data.subwork.length > 0 && response.data.code !== code) {
          const queryStringStringify = queryString.stringify(
            {
              parent_id: response.data.code,
            },
            {
              skipNull: true,
            }
          )
          window.history.replaceState(
            null,
            null,
            `/works/view/${code}?${queryStringStringify}`
          )
        } else {
          window.history.replaceState(null, null, `/works/view/${code}`)
          commandStore.getSideMenuCounter([
            'WORK',
            'PROPOSAL',
            'INTERNAL_MESSAGE',
            'INCOMING',
            'OUTGOING',
            'ELEC_DOC'
          ])
          loadingAnimationStore.setShowSpinInline(true)
        }
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.setShowSpinInline(false)
      }
    },
    [loadingAnimationStore, handleOpenDrawerWork, workStore, commandStore]
  )

  const handleOpenWorkDetailV2 = useCallback(
    async code => {
      loadingAnimationStore.setShowSpinInline(true)
      handleOpenDrawerWork()
      try {
        const response = await workStore.getWorkDetailV2(code)
        if (response.data.subwork.length > 0 && response.data.code !== code) {
          const queryStringStringify = queryString.stringify(
            {
              parent_id: response.data.code,
            },
            {
              skipNull: true,
            }
          )
          window.history.replaceState(
            null,
            null,
            `/works/view/${code}?${queryStringStringify}`
          )
        } else {
          window.history.replaceState(null, null, `/works/view/${code}`)
          commandStore.getSideMenuCounter([
            'WORK',
            'PROPOSAL',
            'INTERNAL_MESSAGE',
            'INCOMING',
            'ELEC_DOC'
          ])
          loadingAnimationStore.setShowSpinInline(true)
        }
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.setShowSpinInline(false)
      }
    },
    [loadingAnimationStore, handleOpenDrawerWork, workStore, commandStore]
  )

  const getWorkList = useCallback(
    async cancelToken => {
      try {
        loadingAnimationStore.setTableLoading(true)
        const res = await workStore.getWorkList(cancelToken)

        if (res) {
          loadingAnimationStore.setTableLoading(false)
        }
      } catch (error) {
        console.log(error)
        message.error(error?.vi || 'Đã có lỗi xảy ra!')
      }
    },
    [loadingAnimationStore, workStore]
  )

  const getWorkListV2 = useCallback(
    async cancelToken => {
      try {
        loadingAnimationStore.setTableLoading(true)
        const res = await workStore.getWorkListV2(cancelToken)

        if (res) {
          loadingAnimationStore.setTableLoading(false)
        }
      } catch (error) {
        console.log(error)
        message.error(error?.vi || 'Đã có lỗi xảy ra!')
      }
    },
    [loadingAnimationStore, workStore]
  )

  useEffect(() => {
    if (isCurrentUserIncluded === true) {
      workStore.getWorkListV2()
    } else {
      workStore.getWorkList()
    }
  }, [listHandler])

  useEffect(() => {
    const source = axios.CancelToken.source()
    ;(async () => {
      if (isCurrentUserIncluded === true) {
        isFetchingMore
          ? await workStore.getWorkListV2()
          : getWorkListV2(source.token)
        setIsFetchingMore(false)
      } else {
        isFetchingMore
          ? await workStore.getWorkList()
          : getWorkList(source.token)
        setIsFetchingMore(false)
      }
    })()

    return () => {
      source.cancel()
    }
  }, [workStore.queryParams])

  const handleChangeFilterImportant = useCallback(async value => {
    setActiveKey([])
    workStore.setQueryParams({
      ...queryParams,
      page: 0,
      is_important: value.target.checked ? true : null,
      parent_id: null,
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParsed,
        is_important: value.target.checked ? true : null,
        parent_id: null,
      },
      {
        skipNull: true,
      }
    )
    history.replace(`/works?${queryStringStringify}`)
    // await getWorkList()
  }, [queryParams, queryStringParsed, workStore, history])

  const onChangeUnReadStatus = useCallback(async value => {
    setActiveKey([])
    workStore.setQueryParams({
      ...queryParams,
      is_unread: value.target.checked ? true : null,
      page: 0,
      parent_id: null,
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParsed,
        is_unread: value.target.checked ? true : null,
        parent_id: null,
      },
      {
        skipNull: true,
      }
    )
    history.replace(`/works?${queryStringStringify}`)
    // await getWorkList()
  }, [queryParams, queryStringParsed, workStore, history])

  const updatedBy = (user_name, updated_at) => {
    if (!user_name) return null
    return (
      <div
        style={{
          flex: '0 0 100%',
          fontSize: 8,
          marginTop: 2,
        }}>
        <span>
          Cập nhật bởi <b>{utils.getNameInCapitalize(user_name)}</b> -{' '}
          <span>{date_format.renderTime(updated_at)}</span>
        </span>
      </div>
    )
  }

  const timeColumn = item => (
    <div>
      {item.due_date ? (
        moment(item.due_date).format(DATE_FORMAT_SLASH)
      ) : (
        <i style={{ color: grayPrimary }}>Không rõ</i>
      )}
    </div>
  )

  const [activeKey, setActiveKey] = useState([])

  useEffect(() => {
    if (queryStringParsed.parent_id) {
      setActiveKey([queryStringParsed.parent_id])
    }
  }, [location])

  const [isFetchingMore, setIsFetchingMore] = useState(false)

  const [markingImportant, setMarkingImportant] = useState({
    status: false,
    workCode: null,
  })

  const handleMarkImportantWork = useCallback(
    async (code, status, parentCode) => {
      try {
        setMarkingImportant({
          status: true,
          workCode: code,
        })
        await WorkRequest.markImportantWork(code, !status)
        if (!parentCode) {
          const workMarkedIndex = workList.findIndex(item => item.code === code)
          if (workMarkedIndex !== -1) {
            const newWorkList = [...toJS(workList)]
            newWorkList[workMarkedIndex].important = !status
            workStore.setWorkList(newWorkList)
          }
        } else {
          const workParentIndex = workList.findIndex(
            item => item.code === parentCode
          )
          if (workParentIndex !== -1) {
            const workMarkedIndex = workList[workParentIndex].subwork.findIndex(
              item => item.code === code
            )
            if (workMarkedIndex !== -1) {
              const newWorkList = [...workList]
              newWorkList[workParentIndex].subwork[
                workMarkedIndex
              ].important = !status
              workStore.setWorkList(newWorkList)
            }
          }
        }
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        setMarkingImportant({
          status: false,
          workCode: null,
        })
        workStore.getWorkList()
      }
    },
    [workList, workStore]
  )

  const handleMarkImportantWorkV2 = useCallback(
    async (code, status, parentCode) => {
      try {
        setMarkingImportant({
          status: true,
          workCode: code,
        })
        const ressponse = await WorkRequest.markImportantWork(code, !status)
        if (!parentCode) {
          const workMarkedIndex = workListV2.findIndex(
            item => item.code === code
          )
          if (workMarkedIndex !== -1) {
            const newWorkList = [...toJS(workListV2)]
            newWorkList[workMarkedIndex].important = !status
            workStore.setWorkListV2(newWorkList)
          }
        } else {
          const workParentIndex = workListV2.findIndex(
            item => item.code === parentCode
          )
          if (workParentIndex !== -1) {
            const workMarkedIndex = workListV2[
              workParentIndex
            ].subwork.findIndex(item => item.code === code)
            if (workMarkedIndex !== -1) {
              const newWorkList = [...workListV2]
              newWorkList[workParentIndex].subwork[
                workMarkedIndex
              ].important = !status
              workStore.setWorkListV2(newWorkList)
            }
          }
        }
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        setMarkingImportant({
          status: false,
          workCode: null,
        })
        workStore.getWorkListV2()
      }
    },
    [workListV2, workStore]
  )

  const onChangePagination = useCallback(
    e => {
      const newPage = e - 1
      workStore.setQueryParams({
        ...queryParams,
        is_unread: queryStringParsed.is_unread,
        page: newPage,
        size: queryParams.size || 10,
      })
      const queryStringStringify = queryString.stringify(
        {
          ...queryStringParsed,
          page: newPage,
          size: queryParams.size || 10,
        },
        { skipNull: true }
      )
      history.replace(`/works?${queryStringStringify}`)
    },
    [queryParams, queryStringParsed, workStore, history]
  )

  const onChangePaginationV2 = useCallback(
    e => {
      const newPage = e - 1
      workStore.setQueryParams({
        ...queryParams,
        is_unread: queryStringParsed.is_unread,
        page: newPage,
        size: queryParams.size || 10,
      })
      const queryStringStringify = queryString.stringify(
        {
          ...queryStringParsed,
          page: newPage,
          size: queryParams.size || 10,
        },
        { skipNull: true }
      )
      history.replace(`/works?${queryStringStringify}`)
    },
    [queryParams, queryStringParsed, workStore, history]
  )

  const handleChangeSize = useCallback(
    async value => {
      workStore.setQueryParams({
        ...queryParams,
        page: 0,
        size: value,
      })
      if (isCurrentUserIncluded === true) {
        await workStore
          .getWorkListV2()
          .finally(() => loadingAnimationStore.setTableLoading(false))
      } else {
        workStore
          .getWorkList()
          .finally(() => loadingAnimationStore.setTableLoading(true))
      }
    },
    [queryParams, workStore, loadingAnimationStore, isCurrentUserIncluded]
  )

  useEffect(() => {
    if (isUnread) {
      workStore.setQueryParams({
        ...queryParams,
        is_unread: isUnread,
      })
      history.replace(`/works?is_unread=${isUnread}`)
    }
  }, [isUnread])

  const checkUnread = item => item.is_read === false

  const getAssigneeList = (assignees, permission) => {
    return selectUserStore.convertListToDefault(
      assignees.filter(
        user => user.permission === permission && user.name_uppercase != null
      )
    )
  }

  const CREATOR = 160
  const CREATED_AT = 100
  const HANDLER = 120
  const DEADLINE_TIME = 120
  const SCROLL_WIDTH = 1000
  const TITLE = 500

  const tableColumns = useMemo(
    () => [
      {
        title: (
          <div>
            <Row gutter={[16, 16]} style={{ marginBottom: '0px' }}>
              <Col xl={6} md={24} xs={24}>
                <span>Nội dung</span>
              </Col>
              <Col xl={9} lg={12} md={12} xs={24}>
                <Checkbox
                  onChange={handleChangeFilterImportant}
                  defaultChecked={!!queryStringParsed.is_important}>
                  <span
                    style={{
                      transform: 'translateY(-1px)',
                      display: 'inline-block',
                      color: 'black',
                    }}>
                    Chọn việc ưu tiên
                  </span>
                </Checkbox>
              </Col>
              <Col xl={9} lg={12} md={12} xs={24}>
                <Checkbox
                  onChange={onChangeUnReadStatus}
                  defaultChecked={!!queryStringParsed.is_unread || isUnread}>
                  <span
                    style={{
                      transform: 'translateY(-1px)',
                      display: 'inline-block',
                      color: 'black',
                    }}>
                    Chọn việc chưa đọc
                  </span>
                </Checkbox>
              </Col>
            </Row>
          </div>
        ),
        width: TITLE,
        render: item => (
          <UnreadTextWork
            text={
              <div>
                <div>
                  {aclStore.checkAccessControlAction(
                    ACL_ACTION_TYPE.uu_tien__WORK
                  ) ? (
                    <Popconfirm
                      title={
                        item.important
                          ? 'Bạn có chắc chắn muốn bỏ đánh dấu ưu tiên công việc này?'
                          : 'Bạn có chắc chắn muốn đánh dấu ưu tiên công việc này?'
                      }
                      okText={item.important ? 'Bỏ đánh dấu' : 'Đánh dấu'}
                      okType={item.important ? 'danger' : 'primary'}
                      onConfirm={async e => {
                        e.stopPropagation()
                        if (isCurrentUserIncluded === true) {
                          handleMarkImportantWorkV2(item.code, item.important)
                        } else {
                          await handleMarkImportantWork(
                            item.code,
                            item.important
                          )
                        }
                      }}
                      onCancel={e => e.stopPropagation()}
                      placement={'top'}
                      cancelText={'Không'}>
                      <Tooltip
                        placement={'left'}
                        title={
                          item.important
                            ? 'Bỏ đánh dấu ưu tiên'
                            : 'Đánh dấu ưu tiên'
                        }>
                        <StarIcon onClick={e => e.stopPropagation()}>
                          {!(
                            markingImportant.status &&
                            markingImportant.workCode === item.code
                          ) ? (
                            item.important ? (
                              <StarFilled
                                style={{ color: '#fadb14', fontSize: 16 }}
                              />
                            ) : (
                              <StarOutlined
                                style={{ fontSize: 16, color: '#595959' }}
                              />
                            )
                          ) : (
                            <LoadingOutlined
                              style={{ fontSize: 16, color: '#595959' }}
                            />
                          )}
                        </StarIcon>
                      </Tooltip>
                    </Popconfirm>
                  ) : (
                    <StarIcon
                      hasSubWork={item.has_subwork || item.subwork?.length > 0}
                      onClick={e => e.stopPropagation()}>
                      {!(
                        markingImportant.status &&
                        markingImportant.workCode === item.code
                      ) ? (
                        item.important ? (
                          <StarFilled
                            style={{ color: '#fadb14', fontSize: 16 }}
                          />
                        ) : (
                          <StarOutlined
                            style={{ fontSize: 16, color: '#595959' }}
                          />
                        )
                      ) : (
                        <LoadingOutlined
                          style={{ fontSize: 16, color: '#595959' }}
                        />
                      )}
                    </StarIcon>
                  )}
                </div>
                <CheckIcon left={'55px'}>
                  {item.status === STATUS_DEFAULT.COMPLETE ? (
                    <CheckCircleFilled
                      style={{ color: greenPrimary, fontSize: 14 }}
                    />
                  ) : (
                    <CheckCircleOutlined
                      style={{ color: '#595959', fontSize: 14 }}
                    />
                  )}
                </CheckIcon>
                <div
                  style={{
                    marginLeft: '70px',
                    fontSize: '12px',
                    maxWidth: '750px',
                  }}>
                  <div
                    style={{
                      fontSize: '12px',
                      maxWidth: '100%',
                      wordWrap: 'break-word',
                      wordBreak: 'break-word',
                      whiteSpace: 'normal',
                    }}>
                    {item.title}
                  </div>
                  {updatedBy(item.updated_user, item.updated_at)}
                </div>
              </div>
            }
            isUnread={checkUnread(item)}
            width={'100%'}
          />
        ),
      },
      {
        title: 'Người xử lý',
        width: HANDLER,
        render: item => {
          const handleList = getAssigneeList(
            item.assignees,
            ASSIGNEE_TYPE.HANDLER
          )
          const leaderList = getAssigneeList(
            item.assignees,
            ASSIGNEE_TYPE.LEADER
          )
          const followerList = getAssigneeList(
            item.assignees,
            ASSIGNEE_TYPE.FOLLOWER
          )
          const departmentApproverList = getAssigneeList(
            item.assignees,
            ASSIGNEE_TYPE.DEPARTMENT_APPROVER
          )
          const formApproverList = getAssigneeList(
            item.assignees,
            ASSIGNEE_TYPE.FORM_APPROVER
          )
          const leaderApproverList = getAssigneeList(
            item.assignees,
            ASSIGNEE_TYPE.LEADER_APPROVER
          )
          const numberIssuerList = getAssigneeList(
            item.assignees,
            ASSIGNEE_TYPE.NUMBER_ISSUER
          )
          const digitalSignerList = getAssigneeList(
            item.assignees,
            ASSIGNEE_TYPE.DIGITAL_SIGNER
          )
          const releaserList = getAssigneeList(
            item.assignees,
            ASSIGNEE_TYPE.RELEASER
          )

          const hasElectronicFlow = item.work_type === WORK_STATUS.ELECTRONIC

          const userListToShow = hasElectronicFlow
            ? [
                ...leaderList,
                ...followerList,
                ...departmentApproverList,
                ...formApproverList,
                ...leaderApproverList,
                ...numberIssuerList,
                ...digitalSignerList,
                ...releaserList,
              ].filter(
                (item, index, self) =>
                  index === self.findIndex(t => t.id === item.id)
              )
            : handleList

          return (
            <UnreadTextWork
              text={
                <div
                  className="assign"
                  style={{ height: '50px' }}
                  onClick={e => e.stopPropagation()}>
                  {userListToShow.length > 0 ? (
                    <PopoverWatchTime
                      userList={userListToShow}
                      title="Danh sách người xử lý"
                      isFullViewer={true}
                      compared_date={VIEWLOG_DATE.work_read_until}
                      typeId={item.code}
                      created_at={item.created_at}
                    />
                  ) : (
                    <EmptyText>Không có người xử lý.</EmptyText>
                  )}
                </div>
              }
              isUnread={checkUnread(item)}
              width={HANDLER}
            />
          )
        },
      },
      {
        title: 'Người tạo',
        width: CREATOR,
        render: item => (
          <UnreadTextWork
            text={
              <ContentBlock className={'user'}>
                {item.assignees.length > 0 ? (
                  <AvatarHasName
                    imgId={
                      item.assignees.find(
                        user => user.permission === ASSIGNEE_TYPE.CREATE
                      )?.image
                    }
                    name={
                      item.assignees.find(
                        user => user.permission === ASSIGNEE_TYPE.CREATE
                      )?.name_uppercase
                    }
                  />
                ) : (
                  <EmptyText>Không rõ.</EmptyText>
                )}
              </ContentBlock>
            }
            isUnread={checkUnread(item)}
            width={CREATOR}
          />
        ),
      },
      {
        title: 'Ngày tạo',
        width: CREATED_AT,
        render: item => (
          <UnreadTextWork
            text={
              <div>
                {item?.created_at ? (
                  moment(item.created_at).format(DATE_FORMAT_SLASH)
                ) : (
                  <i style={{ color: grayPrimary }}>Không rõ</i>
                )}
              </div>
            }
            isUnread={checkUnread(item)}
            width={CREATED_AT}
          />
        ),
      },
      {
        title: 'Hạn hoàn thành',
        width: DEADLINE_TIME,
        render: item => (
          <UnreadTextWork
            text={
              <div>
                {WORK_STATUS.ALL_OTHER.includes(queryParams.work_type) && (
                  <div>{StatusTag(TYPE_STATUS.WORK, item.work_type)}</div>
                )}
                {timeColumn(item)}
              </div>
            }
            isUnread={checkUnread(item)}
          />
        ),
      },
    ],
    [
      handleChangeFilterImportant,
      onChangeUnReadStatus,
      queryStringParsed.is_important,
      queryStringParsed.is_unread,
      isUnread,
      markingImportant.status,
      markingImportant.workCode,
      isCurrentUserIncluded,
      queryParams.work_type,
    ]
  )

  const activeFilterCount =
    (queryParams?.permission ? 1 : 0) +
    (queryParams?.from_date || queryParams?.to_date ? 1 : 0) +
    (queryParams?.status ? 1 : 0) +
    (Array.isArray(queryParams?.assignee)
      ? queryParams.assignee.length
      : queryParams?.assignee
      ? 1
      : 0)

  return (
    <ContentBlockWrapper style={{ minHeight: 'calc(100vh - 140px)' }}>
      <AppPageHeader
        title="Danh sách công việc"
        addon={
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Input.Search
              size="large"
              allowClear
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
              onSearch={handleQuickSearch}
              placeholder="Tìm kiếm theo tiêu đề..."
              className="rounded-search"
              style={{ width: 300 }}
            />
            <div ref={filterBtnRef} style={{ position: 'relative' }}>
              <Popover
                content={<AdvanceFilterBlock 
                  onClose={() => setShowAdvanceFilter(false)} 
                  dispatchUserFilter={dispatchUserFilter}
                  isUnread={isUnread}
                  handleChangeFilterImportant={handleChangeFilterImportant}
                  onChangeUnReadStatus={onChangeUnReadStatus}
                  handleCloseCollapse={() => setActiveKey([])}
                />}
                trigger="click"
                visible={showAdvanceFilter}
                onVisibleChange={visible => setShowAdvanceFilter(visible)}
                placement="bottomRight"
                getPopupContainer={() => filterBtnRef.current || document.body}
              >
                <Badge count={activeFilterCount} size="small" offset={[-2, 2]}>
                  <Button size="large" icon={<SlidersOutlined />} style={{ borderRadius: 6 }} />
                </Badge>
              </Popover>
            </div>
            <Button
              size="large"
              icon={<SyncOutlined spin={isSyncing} />}
              loading={isSyncing}
              onClick={openSyncModal}
              style={{ borderRadius: 6 }}
            >
              {isSyncing ? 'Đang đồng bộ...' : 'Đồng bộ dữ liệu'}
            </Button>
            <Button
              size="large"
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={() => {
                history.push('/works/create')
              }}
            >
              Tạo mới công việc
            </Button>
          </div>
        }
      />
      <style>{`
        /* Cho trường hợp ô search và nút bị chia làm 2 khối */
        .rounded-search .ant-input-group > .ant-input,
        .rounded-search .ant-input-group > .ant-input-affix-wrapper,
        .rounded-search .ant-input-wrapper > .ant-input,
        .rounded-search .ant-input-wrapper > .ant-input-affix-wrapper {
          border-top-left-radius: 20px !important;
          border-bottom-left-radius: 20px !important;
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }
        .rounded-search .ant-input-group-addon > .ant-btn,
        .rounded-search .ant-input-search-button {
          border-top-right-radius: 20px !important;
          border-bottom-right-radius: 20px !important;
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
        /* Đảm bảo khung input bên trong nếu có cũng không bị bo góc phải */
        .rounded-search .ant-input-group > .ant-input-affix-wrapper > .ant-input {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }
        /* Cho trường hợp icon nằm gọn bên trong */
        .rounded-search.ant-input-affix-wrapper {
          border-radius: 20px !important;
        }
        /* Table Styles */
        .ant-table-thead > tr > th {
          background-color: #e6f7ff !important;
          border-right: none !important;
          color: rgba(0, 0, 0, 0.85) !important;
        }
        .ant-table-thead > tr > th::before {
          display: none !important;
        }
        .ant-table-thead > tr > th:first-child {
          border-top-left-radius: 12px !important;
        }
        .ant-table-thead > tr > th:last-child {
          border-top-right-radius: 12px !important;
        }
        .ant-table-tbody > tr > td {
          border-right: none !important;
        }
      `}</style>
      <SyncImsatCredentialsModal
        visible={syncModalVisible}
        username={syncUsername}
        onUsernameChange={setSyncUsername}
        password={syncPassword}
        onPasswordChange={setSyncPassword}
        rememberPassword={rememberPassword}
        onRememberPasswordChange={setRememberPassword}
        hasSavedPassword={hasSavedPassword}
        error={syncError}
        loading={isSyncing}
        onOk={handleSync}
        onCancel={closeSyncModal}
      />
      <TableComponent
        style={{ maxWidth: '100%', overflow: 'clip' }}
        onRow={item => {
          return {
            onClick: async e => {
              e.stopPropagation()
              if (isCurrentUserIncluded === true) {
                if (!item.is_read) {
                  workStore.setIsReadTaskV2({
                    code: item.code,
                    parent_code: null,
                  })
                  WorkRequest.markAsReadWork(item.code).catch(console.error)
                }
              } else {
                if (!item.is_read) {
                  workStore.setIsReadTask({
                    code: item.code,
                    parent_code: null,
                  })
                  WorkRequest.markAsReadWork(item.code).catch(console.error)
                }
              }
              history.push('/works/view/' + item.code)
            },
          }
        }}
        rowKey={item => item.code}
        dataSource={isCurrentUserIncluded ? workListV2 : workList}
        columns={tableColumns}
        pagination={false}
        scroll={{ x: SCROLL_WIDTH }}
        loading={{
          tip: 'Đang tải văn bản...',
          spinning: loadingAnimationStore.tableLoading,
        }}
      />
      <div className="customPaginationWrapper" style={{ padding: '0 24px 24px 24px' }}>
        <div className="left-content-box">
          <span>Hiển thị</span>
          <Select
            value={queryParams.size || 10}
            onChange={handleChangeSize}
            style={{ width: 110 }}
            className="custom-select">
            <Select.Option value={10}>10 / trang</Select.Option>
            <Select.Option value={20}>20 / trang</Select.Option>
            <Select.Option value={50}>50 / trang</Select.Option>
            <Select.Option value={100}>100 / trang</Select.Option>
          </Select>
          <span>Đi đến</span>
          <InputNumber
            min={1}
            max={Math.max(1, Math.ceil((isCurrentUserIncluded ? totalWorkV2 : totalWork) / (queryParams.size || 10)))}
            value={queryParams.page + 1}
            onPressEnter={e => {
              const value = e.target.value
              if (value) {
                if (isCurrentUserIncluded) {
                  onChangePaginationV2(Number(value))
                } else {
                  onChangePagination(Number(value))
                }
              }
            }}
            onBlur={e => {
              const value = e.target.value
              if (value) {
                if (isCurrentUserIncluded) {
                  onChangePaginationV2(Number(value))
                } else {
                  onChangePagination(Number(value))
                }
              }
            }}
            className="custom-input-number"
          />
        </div>
        {isCurrentUserIncluded === true ? (
          <Pagination
            onChange={e => onChangePaginationV2(e)}
            hideOnSinglePage={true}
            total={totalWorkV2}
            pageSize={queryParams.size || 10}
            current={queryParams.page + 1}
            showSizeChanger={false}
            showLessItems
            className="customPagination"
          />
        ) : (
          <Pagination
            onChange={e => onChangePagination(e)}
            hideOnSinglePage={true}
            total={totalWork}
            pageSize={queryParams.size || 10}
            current={queryParams.page + 1}
            showSizeChanger={false}
            showLessItems
            className="customPagination"
          />
        )}
      </div>
    </ContentBlockWrapper>
  )
}

export default inject(
  'workStore',
  'selectUserStore',
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore',
  'aclStore',
  'documentAccessibilityStore'
)(observer(ListWork))
